import { giphyDarkGrey } from '@giphy/js-brand'
import React, { useContext } from 'react'
import Channels from 'shared/components/creation/info-fields/fields/channels'
import styled from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../../../constants'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import Instructions from '../field-instructions'
import Title from '../field-title'
import { CreationToolUploadContext } from '../manager'

const Container = styled(UploadFieldBlock as any)`
    grid-column: span 4;
`

// overrides to make the channel selector match new designs.
// we should remove this one day when we update the design everywhere...
const ChannelsWrapper = styled.div`
    > div {
        margin: 0;
        min-height: 40px;
    }

    input {
        background: ${giphyDarkGrey};
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        width: calc(100% - 40px);
    }
    input + div {
        border-top-right-radius: ${BORDER_RADIUS_SMALL}px;
        border-bottom-right-radius: ${BORDER_RADIUS_SMALL}px;
        height: 40px;
        line-height: 42px;
        width: 40px;
    }
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadCollections = ({ className, field }: Props) => {
    const { setChannelId } = useContext(CreationToolUploadContext)

    const onChange = ({ channelId }) => {
        setChannelId(`${channelId}`)
    }

    return (
        <Container className={className}>
            <Title field={field} />
            <ChannelsWrapper>
                <Channels showLabel={false} onChange={onChange} />
            </ChannelsWrapper>
            <Instructions field={field} />
        </Container>
    )
}

export default CreationUploadCollections
